<template>
  <el-container class="layout-container-demo">
    <el-header class="shadow-lg d-print-none" style="padding: 0; height: 70px">
      <b-card class="p-0 m-0" no-body>
        <NavBarComp />
      </b-card>
    </el-header>
    <el-container>
      <el-aside class="shadow-lg d-print-none" width="auto">
        <b-card class="p-0 m-0" no-body style="height: 100%">
          <el-scrollbar>
            <Menu />
          </el-scrollbar>

          <div class="text-center py-2 align-items-center m-0 p-0">
            <span class="logo-lg" style="cursor: pointer" @click="goToExternalSite">
              <img :src="tenantInfo?.logo ?? ''" class="img-thumbnail shadow" width="40" />
            </span>
            <el-tooltip :content="tenantInfo?.tenant_name" effect="light" placement="top">
              <div class="text-center" style="cursor: pointer" @click="goToExternalSite">
                <div class="text-truncate" style="max-width: 55px; margin: auto">
                  {{ tenantInfo?.tenant_name }}
                </div>
              </div>
            </el-tooltip>
          </div>
        </b-card>
      </el-aside>
      <el-main class="pb-1 core-parent-element">
        <!--        TODO: Temp comment it -->
        <!--        <PageBreadcrumb   />-->
        <slot />
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import NavBarComp from '@/components/nav-bar.vue';
import usePlanPrice from '@/composable/plan-price';

const { tenantInfo } = usePlanPrice();

function goToExternalSite() {
  if (tenantInfo?.value?.website) window.open(tenantInfo.value.website, '_blank'); // Replace with your external URL
}
</script>

<style>
.core-parent-element {
  height: 90vh;
}

@media print {
  .core-parent-element {
    height: auto;
  }
}

.layout-container-demo {
  height: 100%;
  display: flex;
  flex-direction: row;
}

.layout-container-demo .el-container {
  height: 100%;
  display: flex;
  flex: 1; /* Ensure it occupies the remaining space */
}

.layout-container-demo .el-header {
  height: 60px; /* Adjust header height */
  line-height: 60px;
}

.layout-container-demo .el-aside {
  flex-shrink: 0;
}

.layout-container-demo .el-main {
  flex: 1;
  overflow-y: auto; /* Enable scrolling */
  padding: 20px;
}

aside {
  height: 90vh;
  max-height: 90%;
  overflow-y: auto;
  @media (max-height: 600px) {
    height: 70vh;
  }

  @media (max-width: 768px) {
    height: auto;
    max-height: 90%;
  }
}
</style>
